import React from "react";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router";
import { checkIsActive, WithChildren } from "../../../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { useLayout } from "../../core";

type Props = {
  to: string;
  title: string;
  icon?: IconDefinition;
  hasBullet?: boolean;
  redirect?: string;
  "data-test-id"?: string;
};

const AsideMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  hasBullet,
  redirect,
  "data-test-id": testId,
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const { config } = useLayout();
  const { aside } = config;
  const navigate = useNavigate();

  const menuItemContent = (
    <>
      <span id="menu-main-link" className="menu-link">
        {hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        )}
        {icon && aside.menuIcon === "svg" && (
          <span className="menu-icon">
            <FontAwesomeIcon icon={icon!} size="lg" style={{ color: "var($cpl-primary)" }} />
          </span>
        )}
        <span id="menu-main-link" className="menu-title">
          {title}
        </span>
        {!redirect && <span className="menu-arrow"></span>}
      </span>
      <div
        id="menu-main-link"
        className={
          !redirect
            ? clsx("menu-sub menu-sub-accordion", { "menu-active-bg": isActive })
            : "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px"
        }
        data-kt-menu-dismiss={redirect}
      >
        {children}
      </div>
    </>
  );

  return (
    <>
      {redirect ? (
        <div
          id="menu-main-link"
          data-test-id={testId}
          className={clsx("menu-item", { "here show": isActive }, "menu-accordion")}
          data-kt-menu-trigger={`{default:'click', lg: 'hover'}`}
          data-kt-menu-placement="right-start"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onClick={(e: any) => {
            if (e.target.id === "menu-main-link") {
              return navigate(redirect);
            }
          }}
        >
          {menuItemContent}
        </div>
      ) : (
        <div
          data-test-id={testId}
          className={clsx("menu-item", { "here show": isActive }, "menu-accordion")}
          data-kt-menu-trigger="click"
        >
          {menuItemContent}
        </div>
      )}
    </>
  );
};

export { AsideMenuItemWithSub };
